/**
 * Created by jonas on 2019-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Linear, Power2, Timeline, TimelineLite, TweenLite} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {CoinsFountain} from "./CoinsFountain";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {HorribleHeroesGameConfig, IHorribleHeroesBigWinRatioConfig} from "../HorribleHeroesGameConfig";
import {HorribleHeroesTextStyles} from "../config/HorribleHeroesTextStyles";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SoundManager} from "../resource/sound/SoundManager";
import {HorribleHeroes} from "../HorribleHeroes";

export class WinTextView extends BaseView {
    private _mainTl: Timeline | null;
    private _layer: ScalableLayer;
    private readonly _fountainLayer: ScalableLayer;
    private _coinsFountain: CoinsFountain;
    private _countupTl: TimelineLite | null;
    private _nextMode: String;
    private _mode: String;
    private _bw_animation: PIXI.spine.Spine;
    private _bw_transition_animation: PIXI.spine.Spine;
    private _countup: PIXI.spine.Spine;
    private _countupEffect: PIXI.spine.Spine;
    private readonly _dimmer: PIXI.Sprite;
    private _waysCount: PIXI.BitmapText;
    private _winText: PIXI.BitmapText;
    private _waysSprite: PIXI.Sprite;
    private _waysContainer: PIXI.Container;
    private _gameData: HorribleHeroesParsedGameData;
    private _noWays: number = 0;
    private _textFadeInTween: TweenLite;
    private _bigWinLevel5Items: PIXI.spine.Spine[] = [];
    //#484
    private _currentLevel: number = 1;

    private _isShowingInitialWin: boolean = false;

    constructor() {
        super();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(360, 360);
        this._dimmer.tint = 0X000000;
        this._dimmer.alpha = 0;
        this._fountainLayer = StageManager.getLayer(HorribleHeroesLayerConfig.BIG_WIN_FOUNTAIN.name);
        this._fountainLayer.addChild(this._dimmer);
        this._coinsFountain = new CoinsFountain(this._fountainLayer);
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.BIG_WIN.name);
    }

    public get(data: HorribleHeroesParsedGameData): void {
        this._nextMode = data.nextMode;
        this._mode = data.mode;
        this._gameData = data;
    }

    /* this functions shows  text  only once during initial win*/
    public showNoOfWaysWonInitialWin(winRatioConfig: IHorribleHeroesBigWinRatioConfig, isBigWin: boolean): void {
        if (this._noWays === 1) {
            this._waysCount.text = this._noWays.toString();
            this._waysSprite.texture = GameResources.getTextures("way")[0];
        } else {
            this._waysSprite.anchor.set(-0.05, 0.5); // just to increase the space between ways text anchor for x is set to -0.05
            this._waysCount.text = this._noWays.toString();
            this._waysSprite.texture = GameResources.getTextures("ways")[0];
        }

        this._waysSprite.anchor.set(0.5, 0.5);
        this._waysCount.pivot.set(this._waysCount.width / 2, 0);
        this._waysCount.scale.set(1.2);
        this._waysSprite.scale.set(1);
        this._waysCount.position.set(-this._waysSprite.width / 2, -this._waysCount.height / 2);
        this._waysSprite.position.set(this._waysCount.width / 2, 0);
        const posY: number = HorribleHeroesGameConfig.instance.REEL_MIDPOINT_Y + 100;

        if (this._noWays) {
            this._waysSprite.visible = true;
            this._waysCount.visible = true;
        } else {
            this._waysSprite.visible = false;
            this._waysCount.visible = false;
        }
        this._waysContainer.y = posY;
        this._waysContainer.pivot.set(0, 0);
        this._waysContainer.x = Helper.getSymbolPositionsOnReelArea(2, 2)[0];
        this._waysContainer.alpha = 0;
        this._waysContainer.visible = true;

        TweenLite.fromTo(this._waysContainer, (isBigWin ? 0.2 : 0), {alpha: 0}, {
            alpha: 0, onComplete: () => {
                this.playCountUpEffect(winRatioConfig, posY);

                TweenLite.to(this._waysContainer, 0.01, {alpha: 1});

                TweenLite.fromTo(this._waysContainer.scale, 0.1, {x: 1, y: 1}, {
                    x: 1.6, y: 1.6, ease: Linear.easeNone, onComplete: () => {
                        TweenLite.fromTo(this._waysContainer.scale, 0.1, {x: 1.6, y: 1.6}, {
                            x: 1.4,
                            y: 1.4,
                            ease: Linear.easeNone
                        });
                    }
                });
            }
        });

        this._isShowingInitialWin = true;
    }

    /* this functions shows  ways text  during toggle*/
    public toggleWayText(waysWon: number, multipliedAmount: number, fadein?: boolean): void {
        this._winText.name = "winText";
        this._winText.text = Number(multipliedAmount).toFixed(2);
        if (waysWon === 1) {
            this._waysSprite.texture = GameResources.getTextures("way")[0];
            this._waysCount.text = waysWon.toString();
        } else {
            this._waysCount.text = waysWon.toString();
            this._waysSprite.texture = GameResources.getTextures("ways")[0];
        }
        this._waysSprite.scale.set(1);
        this._waysContainer.scale.set(1);
        this._waysCount.scale.set(1.2);
        this._winText.scale.set(1);

        this._waysContainer.visible = true;
        this._waysSprite.visible = true;
        this._waysCount.visible = true;
        this._winText.visible = true;

        this._winText.x = -this._winText.width / 2;
        this._winText.y = -170;

        this._waysSprite.anchor.set(0.5, 0.5);
        this._waysCount.pivot.set(this._waysCount.width / 2, 0);
        this._waysCount.scale.set(1.2);
        this._waysSprite.scale.set(1);

        this._waysCount.position.set(-this._waysSprite.width / 2, -this._waysCount.height / 2 - 40);
        this._waysSprite.position.set(this._waysCount.width / 2, -40);

        this._waysContainer.y = HorribleHeroesGameConfig.instance.REEL_MIDPOINT_Y + 100;
        this._waysContainer.x = Helper.getSymbolPositionsOnReelArea(2, 2)[0];

        if (fadein) {
            this._waysContainer.alpha = 0;

            this._textFadeInTween = TweenLite.to(this._waysContainer, 0.2, {alpha: 1, ease: Power2.easeIn});
        } else {
            this._waysContainer.alpha = 1;
        }

        this._isShowingInitialWin = false;
    }

    public fadeOutToggleText(): void {
        this._waysContainer.addChild(this._waysSprite, this._waysCount, this._winText);
        TweenLite.to((this._waysContainer), 0.2, {alpha: 0, ease: Power2.easeOut});
    }

    public hideToggleText(): void {
        this._winText.visible = false;
        this._waysContainer.visible = false;
    }

    public getStartAnimation(config: IHorribleHeroesBigWinRatioConfig): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        //#485
        this._currentLevel = config.level;
        // #230
        if (config.level === 5) {
            tl.add(() => this.playBigWinLevel5());
        } else {
            if (config.level === 1) {
                tl.add([
                    () => {
                        this.playBgAnimation("fireBackgroundAnimation");
                        this.playBgAnimation("fireForegroundAnimation");
                    },
                    TweenLite.to(this._dimmer, 0.4, {alpha: 0.6})
                ], 0);
            }
            // if dimmer is not at 0.6 alpha for levels other than 5th.
            else if (this._dimmer.alpha !== 0.6) {
                tl.add(() => this._dimmer.alpha = 0.6, 0);
            }

            tl.add(() => {
                if (!this._bw_animation.visible) {
                    this._bw_animation.updateTransform();
                    this._bw_animation.visible = true;
                }
                this._bw_animation.alpha = 0;
                TweenLite.to(this._bw_animation, 0.4, {alpha: 1, ease: Linear.easeIn});
                if (this._currentLevel === 2 && HorribleHeroes.api.gameClientConfiguration.useCensoredGfxUS) {
                    this.playSpine(this._bw_animation, "bigWinStartLevel" + config.level + "_US_animation", false);
                } else {
                    this.playSpine(this._bw_animation, "bigWinStartLevel" + config.level, false);
                }
            }, 0);
            tl.add(() => {
                this._coinsFountain.startFountain(config.level);
                if (this._currentLevel === 2 && HorribleHeroes.api.gameClientConfiguration.useCensoredGfxUS) {
                    this.playSpine(this._bw_animation, "bigWinLoopLevel" + config.level + "_US_animation", true);
                } else {
                    this.playSpine(this._bw_animation, "bigWinLoopLevel" + config.level, true);
                }
            }, 0.6);
        }

        this._mainTl = tl;

        return tl;
    }

    public getEndAnimation(config: IHorribleHeroesBigWinRatioConfig, isLastLevel: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        //#485
        if (config.level !== 1) {//to not play in th begin
            this._bw_transition_animation.updateTransform();
            this._bw_transition_animation.visible = true;
            this.playSpine(this._bw_transition_animation, "bigwinTransitioneffect", false);
        }
        if (config.level === 5) {
            this.playBigWinLevel5End();
        } else {
            if (isLastLevel) {
                this._coinsFountain.stopFountain();
            }
        }

        return tl;
    }

    /*shows Effects behind countups*/
    public playCountUpEffect(winRatioConfig: IHorribleHeroesBigWinRatioConfig, posY: number): void {
        this._countupEffect.visible = false;
        this._countupEffect.state.clearTracks();

        if (winRatioConfig.type === "large" || winRatioConfig.type === "medium") {
            this._countupEffect.updateTransform();
            this._countupEffect.visible = true;
            this._countupEffect.y = posY;
            this.playSpine(this._countupEffect, winRatioConfig.type + "Win", false);
        }
    }

    public playBehindCountup(winRatioConfig: IWinRatioConfig): void {
        if (winRatioConfig.type === "large" || winRatioConfig.type === "medium") {
            this._countup.updateTransform();
            this._countup.visible = true;
            this.playSpine(this._countup, "countup", false);

            // #474
            SoundManager.playCountUpFire();
        }
    }

    public stopAllEffects(): void {
        this.stopBgAnimation("fireForegroundAnimation");

        this._bw_transition_animation.visible = false;
        this._bw_transition_animation.state.clearTracks();
    }

    // this method is called when "Total amount won has stayed on the screen for required time", from CountUpView.ts
    public hideCountUp(): void {
        this._countup.visible = false;
        this._countup.state.clearTracks();
        this._countup.scale.set(1);

        this.fadeOutToggleText();
    }

    public end(displayDuration: number, fadeOutDuration: number): TimelineLite {
        this.stopBgAnimation("fireBackgroundAnimation");

        //#485 to play endAnimation
        let endDuration: number = 0;
        if (this._currentLevel !== 5) {
            endDuration = this._bw_animation.spineData.findAnimation("bigWinEndLevel" + this._currentLevel).duration;
        }

        const tl: TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._dimmer, fadeOutDuration, {alpha: 0}), 0);
        tl.add(() => {
            if (this._currentLevel !== 5) {
                if (this._currentLevel === 2 && HorribleHeroes.api.gameClientConfiguration.useCensoredGfxUS) {
                    this.playSpine(this._bw_animation, "bigWinEndLevel" + this._currentLevel + "_US_animation", false);
                } else {
                    this.playSpine(this._bw_animation, "bigWinEndLevel" + this._currentLevel, false);
                }
            } else {
                this.reset();//for level 5
            }
        }, displayDuration);
        if (this._currentLevel !== 5) {
            tl.add(() => {
                this.reset();
            }, displayDuration + endDuration);
        }
        return tl;
    }

    public abort(toRatioConfig: IHorribleHeroesBigWinRatioConfig): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => this.reset()
        });
        tl.add(() => {
            this.stopBgAnimation("fireBackgroundAnimation");
            this.stopBgAnimation("fireForegroundAnimation");
            this._coinsFountain.stopFountain();

            if (toRatioConfig.level === 5) {
                if (this._bw_animation) {
                    this._bw_animation.visible = false;
                    this._bw_animation.state.clearTracks();
                }
                this._dimmer.alpha = 1;

                this.playBigWinLevel5End();
            } else {
                //598
                if (this._currentLevel === 2 && HorribleHeroes.api.gameClientConfiguration.useCensoredGfxUS) {
                    this.playSpine(this._bw_animation, "bigWinEndLevel" + toRatioConfig.level + "_US_animation", false);
                } else {
                    this.playSpine(this._bw_animation, "bigWinEndLevel" + toRatioConfig.level, false);
                }

            }
        });
        tl.add(() => this.reset(), 0.3);
        return tl;
    }

    public reset(): void {
        this._coinsFountain.stopFountain();
        if (this._mainTl) {
            if (this._mainTl.isActive()) {
                this._countupTl!.pause();
                this._countupTl!.kill();
            }
        }
        if (this._bw_animation) {
            this._bw_animation.visible = false;
            this._bw_animation.state.clearTracks();
        }
        this.stopBgAnimation("fireBackgroundAnimation");
        this.stopBgAnimation("fireForegroundAnimation");
        this._dimmer.alpha = 0;

        let item: PIXI.spine.Spine;
        for (let i: number = 0; i < this._bigWinLevel5Items.length; i++) {
            item = this._bigWinLevel5Items[i];
            item.visible = false;
            item.state.clearTracks();
        }
    }

    protected onResize(data: IResizeData): void {
        const screenWidth: number = data.width,
            screenHeight: number = data.height;

        this._dimmer.width = screenWidth + 100;
        this._dimmer.height = screenHeight + 100;
        this._bw_animation.scale.set((data.width < 1277) ? 0.6 : 1);

        if (NolimitApplication.isLandscape) {
            this._layer.getChildByName("StripTop").position.set(360);
            this._layer.getChildByName("StripBottom").position.set(360);
            this._layer.getChildByName("ChainLeft").position.set(390, 360);
            this._layer.getChildByName("ChainRight").position.set(330, 360);

            this._layer.getChildByName("FanSkull").scale.set(1);
        } else {
            this._layer.getChildByName("StripTop").position.set(100);
            this._layer.getChildByName("StripBottom").position.set(660);
            this._layer.getChildByName("ChainLeft").position.set(560, 50);
            this._layer.getChildByName("ChainRight").position.set(170, 62);

            this._layer.getChildByName("FanSkull").scale.set(0.75);
        }
    }

    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, BalanceEvent.BET, () => this.onBet());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected initAnimations(): void {
        this._bw_animation = new PIXI.spine.Spine(GameResources.getSpineAsset("bigwinAnimation"));
        this._bw_animation.visible = false;
        this._bw_animation.position.set(360);

        this._bw_transition_animation = new PIXI.spine.Spine(GameResources.getSpineAsset("bigwinTransitionEffect"));
        this._bw_transition_animation.visible = false;
        this._bw_transition_animation.position.set(360);

        this._countupEffect = new PIXI.spine.Spine(GameResources.getSpineAsset("countupEffect"));
        this._countupEffect.visible = false;
        this._countupEffect.position.set(360);

        this._countup = new PIXI.spine.Spine(GameResources.getSpineAsset("countup"));
        this._countup.visible = false;
        this._countup.position.set(360);

        let bwEffectBack: PIXI.Container = this.getFireEffectAnimation("fireBackgroundAnimation", 1.5),
            bwEffectFront: PIXI.Container = this.getFireEffectAnimation("fireForegroundAnimation", 1);

        this._fountainLayer.addChild(bwEffectBack);
        this._fountainLayer.addChild(this._countup);
        this._fountainLayer.addChild(bwEffectFront);
        this._layer.addChild(this._bw_transition_animation);
        this._layer.addChild(this._bw_animation);
        this._layer.addChild(this._countupEffect);
        this._waysCount = new PIXI.BitmapText("", HorribleHeroesTextStyles.WAYS_FONT);
        this._winText = new PIXI.BitmapText("", HorribleHeroesTextStyles.FS_OUTRO_COUNT);
        this._waysSprite = new PIXI.Sprite(GameResources.getTextures("ways")[0]);
        this._waysContainer = new PIXI.Container();
        this._layer.addChild(this._waysContainer);
        this._waysContainer.addChild(this._waysSprite, this._waysCount, this._winText);
        this._waysContainer.visible = false;
        this._waysContainer.name = "waysContainer";

        // #230
        this.createBigWinLevel5Items();
    }

    private onBet(): void {
        if (this._textFadeInTween) {
            this._textFadeInTween.pause();
            this._textFadeInTween.kill();
        }

        // #396
        this._countupEffect.visible = false;
        this._countupEffect.state.clearTracks();

        if (!this._isShowingInitialWin) {
            this.hideToggleText();
        }
    }

    private onGameDataParsed(data: HorribleHeroesParsedGameData): void {
        this._gameData = data;
        this._noWays = 0;
        let dataLength: number = this._gameData.betWins.length;
        for (let i: number = 0; i < dataLength; i++) {
            let data = this._gameData.betWins[i] as IBetWayWinData;
            this._noWays = data.numberOfCombinations + this._noWays;
        }

        this._isShowingInitialWin = false;
    }

    private getFireEffectAnimation(containerName: string, scaleIndex: number): PIXI.Container {
        let animTopLeft: TimelineSprite = new TimelineSprite(GameResources.getTextures("fountainBgJpgSeq"), 30),
            animTopRight: TimelineSprite = new TimelineSprite(GameResources.getTextures("fountainBgJpgSeq"), 30),
            animBottomLeft: TimelineSprite = new TimelineSprite(GameResources.getTextures("fountainBgJpgSeq"), 30),
            animBottomRight: TimelineSprite = new TimelineSprite(GameResources.getTextures("fountainBgJpgSeq"), 30);

        animTopLeft.position.set(0, 0);
        animTopLeft.scale.set(1, 1);
        animTopLeft.blendMode = PIXI.BLEND_MODES.ADD;

        animTopRight.position.set(700, 0);
        animTopRight.scale.set(-1, 1);
        animTopRight.blendMode = PIXI.BLEND_MODES.ADD;

        animBottomLeft.position.set(0, 700);
        animBottomLeft.scale.set(1, -1);
        animBottomLeft.blendMode = PIXI.BLEND_MODES.ADD;

        animBottomRight.position.set(700, 700);
        animBottomRight.scale.set(-1, -1);
        animBottomRight.blendMode = PIXI.BLEND_MODES.ADD;

        let animContainer: PIXI.Container = new PIXI.Container();
        animContainer.name = containerName;
        animContainer.scale.set(scaleIndex);
        if (scaleIndex > 1) {
            animContainer.position.set(-160, -160);
        } else {
            animContainer.position.set(0, 0);
        }

        animContainer.alpha = 0;
        animContainer.addChild(animTopLeft, animTopRight, animBottomLeft, animBottomRight);
        return animContainer;
    }

    private createBigWinLevel5Items(): void {
        const itemNames: string[] = ["Center", "FanSkull", "StripTop", "StripBottom", "ChainLeft", "ChainRight", "Warning", "Splatter"],
            prefix: string = "bigWinLevel5";

        for (let i: number = 0; i < itemNames.length; i++) {
            let item: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(prefix + itemNames[i]));
            item.visible = false;
            item.position.set(360);
            item.name = itemNames[i];
            this._layer.addChild(item);
            this._bigWinLevel5Items.push(item);
        }
    }

    private playBgAnimation(containerName: string): void {
        let bgAnimContainer: PIXI.Container = (this._fountainLayer.getChildByName(containerName) as PIXI.Container);
        bgAnimContainer.children.forEach((jpgSeq: PIXI.DisplayObject) => {
            (<TimelineSprite>jpgSeq).playLoop();
        });
        TweenLite.to(bgAnimContainer, 0.4, {alpha: 1, ease: Linear.easeIn});
    }

    private stopBgAnimation(containerName: string): void {
        let bgAnimContainer: PIXI.Container = (this._fountainLayer.getChildByName(containerName) as PIXI.Container);
        bgAnimContainer.children.forEach((jpgSeq: PIXI.DisplayObject) => {
            (<TimelineSprite>jpgSeq).stopLoop();
        });
        TweenLite.to(bgAnimContainer, 0.4, {alpha: 0, ease: Linear.easeIn});
    }

    private playBigWinLevel5(): void {
        if (this._bw_animation) {
            this._bw_animation.visible = false;
            this._bw_animation.state.clearTracks();
        }
        this._coinsFountain.stopFountain();
        this._dimmer.alpha = 1;
        this.stopBgAnimation("fireBackgroundAnimation");
        this.stopBgAnimation("fireForegroundAnimation");

        const startDuration: number = this._bigWinLevel5Items[0].spineData.findAnimation("start").duration;
        for (let i: number = 0; i < this._bigWinLevel5Items.length; i++) {
            let item: PIXI.spine.Spine = this._bigWinLevel5Items[i];

            item.updateTransform();
            item.visible = true;
            this.playSpine(item, "start", false);
            TweenLite.delayedCall(startDuration, () => this.playSpine(item, "loop", true));
        }
    }

    private playBigWinLevel5End(): void {
        let item: PIXI.spine.Spine;
        for (let i: number = 0; i < this._bigWinLevel5Items.length; i++) {
            item = this._bigWinLevel5Items[i];
            if (!item.visible) {
                item.updateTransform();
                item.visible = true;
            }
            this.playSpine(item, "end", false);
        }
    }

    private playSpine(item: PIXI.spine.Spine, animName: string, loop: boolean): void {
        item.state.clearTracks();
        item.skeleton.setSlotsToSetupPose();
        item.skeleton.setToSetupPose();
        item.state.setEmptyAnimation(0, 0);
        item.state.setAnimation(0, animName, loop);
    }
}